export const checkIfAdded = (wishlistType, wishlistId) => `/api/v1/member/wishlist/${wishlistType}/${wishlistId}/exists`;
export const addToWishlist = '/api/v1/member/wishlist';
export const removeFromWishlist = (wishlistType, wishlistId) => `/api/v1/member/wishlist/${wishlistType}/${wishlistId}`;

export const getWishlistItems = ({page = 1, limit = 10, orderBy = 'title'}) => {
    return `/api/v1/member/wishlist?page=${page}&limit=${limit}&orderBy=${orderBy}`;
};


